<template>
  <div
    v-if="show" 
    class="el-date-range-picker__content"
    style="position: absolute;background: #fff;height: 100%;"
    :style="{right: pos === 'right' ? 0 : 'auto', left: pos === 'left' ? 0 : 'auto'}">
    <div class="el-date-picker__header" style="margin: 0;" :class="{ 'el-date-picker__header--bordered': currentView === 'year' || currentView === 'month' }" v-show="currentView !== 'time'">
      <button type="button" @click="prevYear" :aria-label="t(`el.datepicker.prevYear`)" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-d-arrow-left"></button>
      <button type="button" @click="prevMonth" v-show="currentView === 'date'" :aria-label="t(`el.datepicker.prevMonth`)" class="el-picker-panel__icon-btn el-date-picker__prev-btn el-icon-arrow-left"></button>
      <span @click="showYearPicker" role="button" class="el-date-picker__header-label">{{ yearLabel }}</span>
      <span @click="showMonthPicker" v-show="currentView === 'date'" role="button" class="el-date-picker__header-label" :class="{ active: currentView === 'month' }">{{ t(`el.datepicker.month${month + 1}`) }}</span>
      <button type="button" @click="nextYear" :aria-label="t(`el.datepicker.nextYear`)" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-d-arrow-right"></button>
      <button type="button" @click="nextMonth" v-show="currentView === 'date'" :aria-label="t(`el.datepicker.nextMonth`)" class="el-picker-panel__icon-btn el-date-picker__next-btn el-icon-arrow-right"></button>
    </div>

    <div class="el-picker-panel__content">
      <year-table v-show="currentView === 'year'" @pick="handleYearPick" :value="value" :default-value="defaultValue ? new Date(defaultValue) : null" :date="date" :disabled-date="disabledDate">
      </year-table>
      <month-table v-show="currentView === 'month'" @pick="handleMonthPick" :value="value" :default-value="defaultValue ? new Date(defaultValue) : null" :date="date" :disabled-date="disabledDate">
      </month-table>
    </div>
  </div>
</template>

<script>
import {
  formatDate,
  parseDate,
  getWeekNumber,
  isDate,
  modifyDate,
  modifyTime,
  modifyWithTimeString,
  clearMilliseconds,
  clearTime,
  prevYear,
  nextYear,
  prevMonth,
  nextMonth,
  changeYearMonthAndClampDate,
  extractDateFormat,
  extractTimeFormat,
  timeWithinRange,
} from "element-ui/src/utils/date-util";
import Locale from "../localeMixin";
// import Clickoutside from "element-ui/src/utils/clickoutside";
import YearTable from "element-ui/packages/date-picker/src/basic/year-table";
import MonthTable from "element-ui/packages/date-picker/src/basic/month-table";
YearTable.mixins = [Locale]
MonthTable.mixins = [Locale]
export default {
  mixins: [Locale],
  components: {
    YearTable,
    MonthTable,
  },
  directives: {
    // Clickoutside,
  },
  props: {
    format: {
      type: String,
      default: ''
    },
    pickerOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    selectionMode: {
      type: String,
      default: "month"
    }
  },
  data() {
    return {
      // selectionMode: 'month',
      firstDayOfWeek: 7,
      currentView: "year",
      cellClassName: '',
      value: "",
      date: new Date(),
      defaultValue: null,
      disabledDate: this.pickerOptions?.disabledDate || '',
      show: false,
      pos: 'left'
    };
  },
  computed: {
    year() {
      return this.date.getFullYear();
    },

    month() {
      return this.date.getMonth();
    },

    week() {
      return getWeekNumber(this.date);
    },

    monthDate() {
      return this.date.getDate();
    },

    footerVisible() {
      return this.showTime || this.selectionMode === "dates";
    },

    yearLabel() {
      const yearTranslation = this.t("el.datepicker.year");
      if (this.currentView === "year") {
        const startYear = Math.floor(this.year / 10) * 10;
        if (yearTranslation) {
          return startYear + " " + yearTranslation + " - " + (startYear + 9) + " " + yearTranslation;
        }
        return startYear + " - " + (startYear + 9);
      }
      return this.year + " " + yearTranslation;
    },
  },
  methods: {
    showMonthPicker() {
      this.currentView = "month";
    },
    showYearPicker() {
      this.currentView = "year";
    },
    prevMonth() {
      this.date = prevMonth(this.date);
    },
    nextMonth() {
      this.date = nextMonth(this.date);
    },
    prevYear() {
      if (this.currentView === "year") {
        this.date = prevYear(this.date, 10);
      } else {
        this.date = prevYear(this.date);
      }
    },

    nextYear() {
      if (this.currentView === "year") {
        this.date = nextYear(this.date, 10);
      } else {
        this.date = nextYear(this.date);
      }
    },
    handleMonthPick(month) {
      if (this.selectionMode === 'month') {
        this.date = modifyDate(this.date, this.year, month, 1);
        this.emit(this.date);
      } else {
        this.date = changeYearMonthAndClampDate(this.date, this.year, month);
        this.$emit('choose', this.date);
        this.currentView = 'date';
        this.show = false;
      }
    },

    handleYearPick(year) {
      if (this.selectionMode === 'year') {
        this.date = modifyDate(this.date, year, 0, 1);
        this.emit(this.date);
      } else {
        this.date = changeYearMonthAndClampDate(this.date, year, this.month);
        this.currentView = 'month';
      }
    },
    emit(value, ...args) {
      if (!value) {
        this.$emit('pick', value, ...args);
      } else if (Array.isArray(value)) {
        const dates = value.map(date => this.showTime ? clearMilliseconds(date) : clearTime(date));
        this.$emit('pick', dates, ...args);
      } else {
        this.$emit('pick', this.showTime ? clearMilliseconds(value) : clearTime(value), ...args);
      }
      this.userInputDate = null;
      this.userInputTime = null;
      this.show = false;
    },
  },
};
</script>
